// Generated by CoffeeScript 2.7.0
var DateTimePicker;

import DatePicker from 'trunks/vue/share/components/datepicker/date_picker.js';

import DynamicDatePicker from 'trunks/vue/share/components/dynamic_date_picker.js';

import TimePicker from 'trunks/vue/share/components/timepicker/time_picker.js';

export default DateTimePicker = Vue.extend({
  components: {
    'time-picker': TimePicker,
    'date-picker': DatePicker,
    'dynamic-date-picker': DynamicDatePicker
  },
  props: {
    initValue: [String, Date],
    viewMode: {
      type: String,
      default: 'date'
    },
    limitStart: Date,
    limitEnd: Date,
    isDynamic: {
      type: Boolean,
      default: false
    },
    showDateValueTip: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {
      value: this.isDynamic ? this.initValue : this.initValue || new Date(),
      viewType: this.viewMode,
      dynamic: this.isDynamic
    };
  },
  template: `<div class="datetimepicker">
  <date-picker :initValue='value'
               :limitStart='limitStart'
               :limitEnd='limitEnd'
               v-if='viewType === "date" && !dynamic'
               @valueChanged='updateDate'
               ref='datePicker' />
  <div class="date-value" v-if='viewType === "time" && showDateValueTip'>
    {{ value.strftime('YYYY年M月DD日') }}
  </div>
  <time-picker :initValue='value'
               v-if='viewType === "time"'
               @valueChanged='updateTime'
               ref='timePicker' />
  <dynamic-date-picker :initValue='value'
                       v-if='viewType == "date" && dynamic'
                       ref='dynamicDatePicker'
                       @valueChanged='updateDynamicDate' />
</div>`,
  watch: {
    viewType: function(new_value) {
      return this.$emit('viewModeChanged', new_value);
    },
    value: function(new_value) {
      return this.$emit('valueChanged', new_value);
    }
  },
  methods: {
    reset: function(value) {
      this.switchViewMode(this.viewMode);
      return this.setValue(value);
    },
    switchViewMode: function(type) {
      return this.viewType = type != null ? type : this.viewType === 'date' ? 'time' : 'date';
    },
    updateTime: function(time) {
      var _old_value;
      _old_value = this.value || new Date();
      return this.value = new Date(_old_value.getFullYear(), _old_value.getMonth(), _old_value.getDate(), time.getHours(), time.getMinutes());
    },
    updateDate: function(date) {
      var _old_value;
      _old_value = this.value || new Date();
      return this.value = new Date(date.getFullYear(), date.getMonth(), date.getDate(), _old_value.getHours(), _old_value.getMinutes());
    },
    updateDynamicDate: function(date) {
      return this.value = date;
    },
    getValue: function() {
      return this.value;
    },
    setDynamic: function(value) {
      return this.dynamic = value;
    },
    setVmValue: function(value) {
      return this.value = value;
    },
    setValue: function(value) {
      var ref, ref1, ref2;
      if ((ref = this.$refs.datePicker) != null) {
        ref.setDate(value);
      }
      if ((ref1 = this.$refs.timePicker) != null) {
        ref1.setTime(value);
      }
      return (ref2 = this.$refs.dynamicDatePicker) != null ? ref2.setDate(value) : void 0;
    }
  }
});
